import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
  visible: { type: Boolean, default: false },
  isAbsolute: { type: Boolean, default: false },
  isFullScreen: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['spinner-container w-100', { 'absolute': __props.isAbsolute, 'flex-centered py-5': !__props.isAbsolute, 'spinner-full-screen': __props.isFullScreen }])
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "spinner-bg" }, [
          _createElementVNode("div", { class: "spinner" })
        ], -1)
      ]), 2))
    : _createCommentVNode("", true)
}
}

})